/* eslint-disable no-console */
import { OPTIONS, getOptions } from './options';

const backgroundColors = {
  DEBUG: '#2e61de',
  ERROR: 'crimson',
  Hub: '#ea891e',
  CFD: '#1bdce3',
  Printers: '#fa8eeb',
  Ably: '#35b858',
};

const badgeRegex = new RegExp(`^(${Object.keys(backgroundColors).join('|')}):\\s?`);

const getBadgeCss = (backgroundColor: TSFixMe) =>
  `background: ${(backgroundColors as any)[backgroundColor]}; color: white; padding: 3px;`;

const getBadges = (args = '') => {
  const badges = [args.includes('%cERROR') ? '%cERROR' : '%cDEBUG'];

  if (typeof args === 'string') {
    const [, badgeType] = args.match(badgeRegex) || [];
    if (badgeType) {
      badges.push(`%c${badgeType}`);
    }
  }

  const badgeCss = badges.reduce((accumulator, value, index) => {
    if (!value) return accumulator;
    let css = `${getBadgeCss(value.replace('%c', ''))}`;

    if (css && index >= 1) {
      css += 'margin-left: 3px;';
    }
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    accumulator.push(css);

    return accumulator;
  }, []);

  return [badges.join(''), ...badgeCss];
};

class Logger {
  static debug(...args: TSFixMe[]) {
    if (!getOptions()[OPTIONS.IS_DEBUG_MODE]) return;

    console.info(
      ...getBadges(...args),
      ...args.map(arg => {
        if (typeof arg === 'string') {
          if (arg.startsWith('%c')) {
            return undefined;
          }
          return arg.replace(badgeRegex, '');
        }
        return arg;
      })
    );
  }

  static warn(...args: TSFixMe[]) {
    console.warn(...args);
  }

  static error(error: TSFixMe, values = {}) {
    Logger.debug('%cERROR', error, {
      ...values,
    });
  }

  static log(...args: TSFixMe[]) {
    console.log(...args);
  }
}

export default Logger;
